const checkEndName = (num: number, arr: string[]) => {
  const str = String(num);
  const idx = str.length - 1;
  if (str.length > 1 && '10' < `${str[idx - 1]}${str[idx]}` && `${str[idx - 1]}${str[idx]}` < '20') return arr[2];
  if (str[idx] === '1') return arr[0];
  if ('1' < str[idx] && str[idx] < '5') return arr[1];
  return arr[2];
};

const writtenTimeFormat = (num: number) => {
  const data = [];
  if (!num) return '';

  const nowDate = new Date().getTime();
  const achiveDate = new Date(num).getTime();
  const result = achiveDate - nowDate + 1000;
  if (result < 0) return '';

  let minutes = Math.floor((result / 1000 / 60) % 60);
  let hours = Math.floor((result / 1000 / 60 / 60) % 24);
  const days = Math.floor(result / 1000 / 60 / 60 / 24);
  if (minutes < 10) minutes = 0 + minutes;
  if (hours < 10) hours = 0 + hours;

  if (days === 1) data.push(`${days} день`);
  if (days > 1) data.push(`${days} дн${checkEndName(days, ['', 'я', 'ів'])}`);
  if (hours) data.push(`${hours} годин${checkEndName(hours, ['у', 'и', ''])}`);
  if (minutes) data.push(`${minutes} хвилин${checkEndName(minutes, ['у', 'и', ''])}`);
  return data.join(', ');
};

export default writtenTimeFormat;
